<div
  [ngClass]="{
    'right-0': toast.isVisible,
    '-right-full': !toast.isVisible
  }"
  class="fixed z-50 bg-gray-950 top-16 max-w-sm w-full p-4 rounded-lg shadow-lg transform transition-all duration-300 ease-in-out"
>
  <div class="flex items-center space-x-4">
    <div class="flex-shrink-0">
      <span *ngIf="toast.type === 'success'" class="text-green-500">
        <i class="fas fa-check-circle"></i>
      </span>
      <span *ngIf="toast.type === 'error'" class="text-red-500">
        <i class="fas fa-times-circle"></i>
      </span>
      <span *ngIf="toast.type === 'info'" class="text-blue-500">
        <i class="fas fa-info-circle"></i>
      </span>
    </div>
    <div class="flex-1">
      <p class="text-white font-medium">{{ toast.message }}</p>
    </div>
    <div class="flex-shrink-0">
      <button (click)="hideToast()" class="text-white hover:text-gray-300">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</div>
